<div class="lum-modal__wrapper">
  <div mat-dialog-title>
    <div class="lum-modal__header justify-space-between w-p100">
      <span class="lum-modal__header-title flex text-large">{{ modalTitle }}</span>
      <div class="lum-modal__header-close">
        <ng-content select="[header-close]"></ng-content>
      </div>
    </div>
  </div>
  <div class="lum-modal__content">
    <div class="lum-modal__body w-p100">
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
</div>
